<div class="dictionary-error">
  <div class="row">
    <div class="col-12 header">
      <div class="logo"></div>
    </div>
    <div class="col-12 content">
      <div class="row">
        <div class="col-12 title">
          <h1>Dicionário de Erros</h1>
        </div>
        <div class="col-11 box-table">
          <table>
            <thead>
              <tr>
                <td>Código</td>
                <td class="text">Chave</td>
                <td class="text">Error_id</td>
                <td class="text">Serv. WF</td>
                <td class="text">Serv. WSO2</td>
                <td class="text">Serv. Adapter</td>
                <td class="text">Método</td>
                <td class="text">Erro</td>
                <td class="text">Descrição</td>
              </tr>
            </thead>
            <tbody *ngFor="let item of listErrorSystem">
              <tr *ngFor="let error of item.error">
                <td>{{ item.cod }} - {{ error.cod }}</td>
                <td class="text">{{ error.cod_key }}</td>
                <td class="text">{{ error.error_id ? error.error_id : 'NA' }}</td>
                <td class="text">{{ item.service_wf ? item.service_wf : 'NA' }}</td>
                <td class="text">{{ item.service_wso2 ? item.service_wso2 : 'NA' }}</td>
                <td class="text">{{ item.service_adapter ? item.service_adapter : 'NA' }}</td>
                <td class="text">{{ item.method ? item.method : 'NA' }}</td>
                <td class="text">{{ error.error_service }}</td>
                <td class="text">{{ error.desc_error }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
